/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var modelGet = require('common/util/modelGet');
var AddressView = require('common/views/AddressView');

var tmplCorpFinCorrespondentFormView = require('../templates/CorpFinCorrespondentFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinCorrespondentFormView,

  className: 'corp-fin-offering-form-view',

  ui: {
    address: '.address'
  },

  regions: {
    address: '@ui.address'
  },

  templateHelpers: function() {
    return { isInvestment: this.model.get('recordCategoryId') === '3' };
  },

  onBeforeShow: function() {
    var record = this.model.get('record') || {};

    this.showChildView(
      'address',
      new AddressView({
        model: new Backbone.Model(),
        objectName: 'corrAddress',
        horizontal: true,
        isRequired: false,
        startingCountry: modelGet(this.model, 'record.corrAddress.country'),
        startingPostalCode: modelGet(this.model, 'record.corrAddress.postalCode'),
        startingCounty: modelGet(this.model, 'record.corrAddress.county')
      })
    );

    Syphon.deserialize(this, record);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.recordId = this.model.get('recordId');
    return formData;
  }
});
